import { APP_INITIALIZER, inject, Provider } from '@angular/core';
import { icons } from '@app/data/icons';
import { SvgIconRegistryService } from 'angular-svg-icon';
import { iconsInitializer } from './custom-icon.initializer';

export const provideIcons = (): Provider => ({
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: () => iconsInitializer(inject(SvgIconRegistryService), icons),
});
